////////////////// COLORS /////////////

export const colGreen = '#b3e830';
export const colDisabledButton = '#f2f0f0';
export const colLightBlueText = '#76d9ff';
